export interface EmailNotificationType {
  type: string;
  label: string;
    id: number;
}

export const emailNotificationsType: EmailNotificationType[] = [
  {
    id: 1,
    type: "sendTaskUpdateEmailNotifications",
    label: "Task Update Notification",
  },
  {
    id: 2,      
    type: "sendCommentEmailNotifications",
    label: "Comment Notification",
  },
  {
    id: 3,
    type: "sendNotificationsForStaleTasks",
    label: "Stale Task Notification",
  },
  {
    id: 4,
    type: "sendStakeholderAssignmentNotifications",
    label: "Stakeholder Assignment Notification",
  },
  {
    id: 5,
    type: "sendNewSEPNotification",
    label: "New SEP Created Notification",
  },
  {
    id: 7,
    type: "sendSepSubscriptionEmailNotifications",
    label: "SEP Subscription Notification",
  },
  {
    id: 8,
    type: "sendAPMPortfolioOwnerEmailNotifications",
    label: "APM Portfolio Owner Notification",
  },
  {
    id: 9,
    type: "sendSepClosureEmailNotifications",
    label: "SEP Closure Notification",
  },
  {
    id: 10,
    type: "sendTaskAssigneeUpdateEmailNotifications",
    label: "Task Assignee Update Notification",
  },
  {
    id: 11,
    type: "sendDepartmentStakeholderAssigneeUpdateEmailNotifications",
    label: "Department Stakeholder Assignee Update Notification",
  },
  {
    id: 12,
    type: "sendIntiatePhaseCompleteEmailNotifications",
    label: "Initiate Phase Complete Notification",
  },
  {
    id: 13,
    type: "sendNotificationForVpandITkeyManagerOnSubmitSep",
    label: "VP and IT Key Manager SEP Submission Notification",
  },
];
